import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import LoginNew from '@/components/LoginNew';
import CreateSurvey from '@/components/CreateSurvey';
import EditSurvey from '@/components/EditSurvey';
import ErrorPage from '@/components/ErrorPage';
import Dashboard from '@/components/Dashboard/Main';
import Preview from '@/components/Preview/Main';
import ForgotPassword from '@/components/ForgotPassword';
import EditResponse from '@/components/EditResponse/Main';
import SearchResponse from '@/components/SearchResponse/Main';

// import PreviewWithSkipLogic from '@/components/PreviewWithSkipLogic/Main'
var { frontHostName, signupUrl } = require('../../config/config.js')
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.ROUTER_BASE,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: LoginNew,
      props: true
    },
    {
      path: '/:whitelabel',
      name: 'LabelLogin',
      component: LoginNew,
      props: true
    },
    {
       path: '/:whitelabel/forgot-pswd',
       name: 'ForgotPassword',
       component: ForgotPassword,
       props: true
    },
    {
      path: '/:whitelabel/createform',
      name: 'CreateForm',
      component: CreateSurvey
    },
    {
      path: '/:whitelabel/editform/:id',
      name: 'EditForm',
      component: EditSurvey
    },
    {
      path: '/:whitelabel/error',
      name: 'ErrorPage',
      component: ErrorPage
    },
    {
      path: '/:whitelabel/createform/:id',
      name: 'Dashboard',
      component: Dashboard,
      props: true
    },
    {
      path: '/:whitelabel/editForms/:id',
      name: 'EditDashboard',
      component: Dashboard,
      props: true
    },
    {
      path: '/:whitelabel/previewform/:id',
      name: 'PreviewForm',
      component: Preview,
      props: true
    },
    {
      path: '/:whitelabel/responseform/:id',
      name: 'ResponseForm',
      component: Preview,
      props: true
    },
    {
      path: '/:whitelabel/editresponseform/:sid/:rid',
      name: 'EditResponseForm',
      component: EditResponse,
      props: true
    },
    {
      path: '/:whitelabel/searchresponseform/:sid',
      name: 'SearchResponseForm',
      component: SearchResponse,
      props: true
    }
    // {  
    //   path: '/responsesurveyskiplogic/:id',
    //   name: 'Responsesurveyskiplogic',
    //   component: PreviewWithSkipLogic,
    //   props: true
    // }
  ]
})
router.beforeEach((to, from, next) => {
  console.log('m here')
  console.log(to)
  console.log(from)
  console.log(next)
  // redirect to login page if not logged in and trying to access a restricted page
  // const publicPages = ["/"];
  // const authRequired = !publicPages.includes(to.path);
  const publicPages = ['/', 'ResponseForm', 'forgot-pswd']
  const authRequired =
    to.name == 'ResponseForm' || to.name == 'LabelLogin' || to.name == 'ForgotPassword' || to.name == "SearchResponseForm"
      ? !publicPages.indexOf(to.name)
      : !publicPages.includes(to.path)
     console.log('Auth value -- ',authRequired) 

  // If someone hit old signup url (reportsys) or enter signup word manully then redriect user to Signup screen
  if(window.location.pathname.toLowerCase().match(/\/signup\b/gi) !== null) {
    console.log('redirected to signup link');
    location.href = signupUrl;
    return;
  }

  // If someone hit old url with reportsys word then redriect user to new URL with my folder
  var reportsysURL = window.location.href.toLowerCase();
  if(reportsysURL.match(/\/reportsys\b/gi) !== null) {
    console.log('redirected to new my folder instead of reportsys');
    location.href = reportsysURL.replace("reportsys", "my");
    return;
  }

  const loggedIn = localStorage.getItem('vue-session-key')

  if (authRequired && !loggedIn) {
    console.log('in auth required function')
    var reg = new RegExp(process.env.DOMAIN_REGEX)
    var parts = window.location.href.split('.')
    if (
      parts.length > 2 &&
      !reg.test(parts[0]) &&
      (parts[1] === process.env.STAGE_DOMAIN ||
        parts[1] === process.env.LIVE_DOMAIN)
    ) {
      let routepath = parts[2].split('/')
      if (routepath[2] && routepath[2].length > 0) {
        console.log('shud be replaced')
        router.replace({
          name: 'LabelLogin',
          params: { domain: parts[0], whitelabel: routepath[1] },
          query: {redirect_url: to.query.redirect_url}
        })
      }
      console.log('with account login link')
    } else {
      console.log('redirected to login link')
      return next('/')
    }
  } else if (loggedIn) {
    console.log('in logged in')
    if (to.path == '/') {
      // let parts = window.location.href.split('.')
      // var whitelabel =
      //   parts[1].includes('com') || parts[1].includes('info')
      //     ? parts[1].split('/')[1]
      //     : parts[2]
      //       ? parts[2].split('/')[1]
      //       : '';
      let whitelabel = router.app.$session.get('whitelabel')
      let requestUserType = router.app.$session.get('requestUserType')

      // To be changed and tested
      if (whitelabel === '') {
        var loc = frontHostName
        location.href = loc
      } else {
        var loc =
          frontHostName +
          process.env.CAKE_BASE_PATH +
          whitelabel +
          (requestUserType == 5 ? process.env.CAKE_PATH : process.env.CAKE_SURVEY_PATH)
        location.href = loc
      }
      return
    }
    if (to.name == 'CreateForm' && from.name == 'Dashboard') {
      return next(from.path)
    }
    if (to.name == 'EditForm' && from.name == 'Dashboard') {
      return next(from.path)
    }

  }

  
  
  if ((to.path === '/' || to.name === 'LabelLogin') && !to.params.domain) {
    console.log('ifffffffffffffffffffffffff');
    var reg = new RegExp("\\b("+process.env.ONLY_DOMAIN_REGEX+")\\b")
    console.log(window.location)
    var parts = window.location.href.split('.')
    // parts[0] = 'http://hispec';
    // parts[1] = 'hispecservices';
    // parts[2] = 'com/doyenhub';
    console.log(window.location.href)
    console.log(parts)
    if (parts[0].includes('//')) parts[0] = parts[0].split('//')[1]
    console.log(parts[0])
    var whitelabel = '';
    if (
      parts.length > 2 &&
      !reg.test(parts[0]) &&
      parts[0].length > 0 &&
      (parts[1] === process.env.STAGE_DOMAIN ||
        parts[1] === process.env.LIVE_DOMAIN)
    ) {
      console.log('subdomain passed')
      if (
        parts[2].includes(process.env.DOMAIN_TARGET1) ||
        parts[2].includes(process.env.DOMAIN_TARGET2)
      ) {
        if (parts[2].split('/')[1] && parts[2].split('/')[1].length > 0) {
          whitelabel = parts[2].split('/')[1]
        }
      }
      let domain = parts[0]
      console.log(domain)
      console.log(whitelabel)
      if(whitelabel == 'forgot-pswd') whitelabel = '';
      router.replace({
        name: 'LabelLogin',
        params: { domain: domain, whitelabel: whitelabel },
        query: {redirect_url: to.query.redirect_url}
      })
      // router.push({
      //   path: '/',
      //   query: {
      //     accountName: parts[0]
      //   }
      // })
    } else {      
          router.replace({
           name: 'Login',
           params: { domain: process.env.DEFAULT_DOMAIN }
          })
          next()  
       
      
    }
  } else {
    console.log('in end else',to)
    next()
  }
})

// router.beforeEach((to, from, next) => {
//   console.log(to)
//   if (to.path != '/') {
//     let user = JSON.parse(localStorage.getItem('user'))
//     if (user) {
//       next()
//     } else {
//       console.log('not logged in')
//       return next('/')
//     }
//   }
// })

// router.beforeEach((to, from, next) => {
//   // redirect to login page if not logged in and trying to access a restricted page

//   const loggedIn = localStorage.getItem('user')
//   console.log(loggedIn)

//   if (loggedIn) {
//     console.log('yes m logged in')
//     if (to.path == '/') {
//       var loc = 'http://' + location.hostname + process.env.CAKE_SURVEY_PATH
//       location.href = loc
//     }

//     next()
//   } else {
//     console.log('shdhsdhj')
//     router.go({path: '/'})

//     next.abort()
//   }
//   // if (to.name == 'CreateSurvey') { router.go({path: to.path}) }
//   // if (to.name == 'EditSurvey') { router.go({path: to.path}) }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js